import { render } from "./FormDesign.vue?vue&type=template&id=6b65df69&scoped=true"
import script from "./FormDesign.vue?vue&type=script&lang=js"
export * from "./FormDesign.vue?vue&type=script&lang=js"

import "./FormDesign.vue?vue&type=style&index=0&id=6b65df69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b65df69"

export default script